<template>
  <div class="mb-4">
    <!--#region -- Content ---->
    <!--#region Tag Area -->

    <div class="caption-label d-flex">
      <div>
        Effective Response
      </div>
    </div>
    <div>
      <div class="row mb-4">
        <div class="col-10">
          <b-form-group label-for="tags-component-select">
            <!-- Prop `add-on-change` is needed to enable adding tags vie the `change` event -->
            <b-form-tags id="tags-component-select"
                         v-model="effectiveValue"
                         size="lg"
                         class="mb-2"
                         add-on-change
                         no-outer-focus>
              <template v-slot="{ tags, inputAttrs, inputHandlers, disabled, removeTag }">
                <ul v-if="tags.length > 0"
                    class="list-inline d-inline-block mb-2 col-4">
                  <!-- <li v-for="tag in tags" :key="tag" class="list-inline-item"> -->
                  <li class="list-inline-item">
                    <b-form-tag @remove="removeTag(tags[tags.length-1])"
                                :title="tags[tags.length-1]"
                                :disabled="disabled"
                                :variant="effectiveVariant(tags[tags.length-1])">{{ tags[tags.length-1] }}</b-form-tag>
                  </li>
                </ul>
                <b-form-select class="col-6"
                               v-bind="inputAttrs"
                               v-on="inputHandlers"
                               :disabled="disabled || availableOptions.length === 0 || tags.length > 0"
                               :options="availableOptions">
                  <template #first>
                    <option v-if="tags.length === 0" disabled value="">Choose one tag</option>
                    <option v-else disabled value="">Remove the selected tag if you want to choose another</option>
                  </template>
                </b-form-select>
                <ul v-if="tags.length > 0"
                    class="list-inline d-inline-block mb-2 col">
                  <li class="list-inline-item">
                    <b-button variant="primary"
                              @click="setAssessUpdateModal('EFFECTIVE_REMARK', tags[tags.length-1]) && updateAssessInfo(updateAssessModalData)">Save</b-button>
                  </li>
                </ul>
              </template>
            </b-form-tags>

          </b-form-group>
        </div>
      </div>
    </div>
    <div class="caption-label d-flex">
      <div>
        Liability Disclaimer
      </div>
    </div>
    <div>
      <div class="row mb-4">
        <div class="col-10">
          <!-- :disabled="!fieldActionEnable('NOT_ESPM_LIABILITY')" -->
          <b-form-checkbox v-model="notEspmLiability"
                           :disabled="!fieldActionEnable('NOT_ESPM_LIABILITY')"
                           @change="setAssessUpdateModal('NOT_ESPM_LIABILITY', notEspmLiability) && updateAssessInfo(updateAssessModalData)"
                           class="mb-2 mr-sm-2 mb-sm-0">
            Not ES PM Liability
          </b-form-checkbox>
        </div>
      </div>
    </div>
    <div class="caption-label d-flex">
      <div>
        PoC Provided
      </div>
    </div>
    <div>
      <div class="row mb-4">
        <div class="col-10">
          <b-form-checkbox v-model="pocProvided"
                           @change="setAssessUpdateModal('IS_POC_PROVIDED', pocProvided) && updateAssessInfo(updateAssessModalData)"
                           class="mb-2 mr-sm-2 mb-sm-0">
            Yes
          </b-form-checkbox>
        </div>
      </div>
    </div>
    <!-- REGION: TABLE FOR ETO SECTOR SKU LIST -->
    <!--
        <div v-if="assessInfo.length === 0" style="padding-top: 10px;">
    <b-alert show variant="primary">
      There is no NRE initiated for this ETO Sector SKU type of ticket.
      Please notify ES PM to create an NRE and then the section for this ETO Sector SKU will be activated.
    </b-alert>
  </div>
  -->
    <!-- END REGION -->

  </div>
</template>

<script>
  export default {
    name: 'gtc-ftie-tag',
    props: {
      prop_assess_info: {
        default: null
      },
      prop_user_sites: {
        default: null
      },
      prop_user: {
        default: null
      },
      prop_page_obj: {
        default: null
      },
    },
    data: function () {
      return {
        effectiveOptions: ['Effective solution in the 1st response',
          'Effective solutions were found in the top 5 responses',
          'Effective solutions were found after 5 responses',
          'No effective solution has been found yet'],
        effectiveValue: [],
        notEspmLiability: false,
        pocProvided: false,
        // tags: [],
        isRouterAlive: true,
        dateFormat: { year: 'numeric', month: 'short', day: 'numeric' },
        assessInfo: null,
        ftiePageObj: null,
        loginUser: null,
        userSites: null,
        actionEnable: false,
        frontEndUrlToUse: this.$session.get('frontEndUrlToUse'),
        ftieId: encodeURIComponent(this.$route.params.ftie_id),
        createBy: null,
        groOwner: null,
        realSkuNo: null,

        searching: false,
        maintianPnHint: '* Please maintain PN first!',
        noneSelectedHint: 'None Selected',
        reloadBusy: false,
        processedIndex: [],
        assessInfoWarning: null,
        updateAssessModalData: {
          field: null,
          valToUpdate: null,
          valBeforeUpdate: null,
        },
        remarkModalData: {
          nreId: null,
          field: 'remark',
          remarkToSyncNew: null,
          remarkToSync: null,
        },
        documentModalData: {
          nreId: null,
          field: 'document',
          documentToSyncNew: null,
          documentToSync: null,
        },
      }
    },
    computed: {
      availableOptions() {
        return this.effectiveOptions.filter(opt => this.effectiveValue.indexOf(opt) === -1)
      },
      userFunctions() {
        return this.$session.get('user_functions');
      },
      userRoles() {
        return this.$session.get('user_roles');
      }
    },
    created() {
      let self = this;
      self.assessInfo = self.prop_assess_info; // JSON.parse(JSON.stringify(self.prop_assess_info)); //self.prop_assess_info;
      if (self.assessInfo !== null) {
        //self.tags = [];
        self.effectiveValue = [];
        if (_.get(self.assessInfo, 'effective_remark', null) !== null) {
          //self.tags.push(_.get(self.assessInfo, 'effective_remark', ''));
          self.effectiveValue.push(_.get(self.assessInfo, 'effective_remark', ''));
        }
      }
      else {
        //self.tags = [];
        self.effectiveValue = [];
      }
      if (self.assessInfo !== null) {
        self.notEspmLiability = _.get(self.assessInfo, 'not_espm_liability', false);
        self.pocProvided = _.get(self.assessInfo, 'is_poc_provided', false);
      }
      self.ftiePageObj = self.prop_page_obj;
      self.createBy = _.get(self.ftiePageObj, 'gtc_owner', null);
      self.groOwner = _.get(self.ftiePageObj, 'gro_owner', null);
      // self.userSites = self.prop_user_sites;
      self.loginUser = self.prop_user;
      self.actionEnable = self.checkActionEnable();
      //console.log("SFDC Copo actionEnable:");
      //console.log(self.actionEnable);
    },
    methods: {
      effectiveVariant(tagVal) {
        let self = this;
        if (tagVal === self.effectiveOptions[0]) {
          return 'success';
        }
        if (tagVal === self.effectiveOptions[1]) {
          return 'info';
        }
        if (tagVal === self.effectiveOptions[self.effectiveOptions.length - 1]) {
          return 'danger';
        }
        return 'dark'
      },
      classObject(input, maxLength) {
        return {
          'text-danger': this.$options.filters['reachLength'](input, maxLength),
          'text-success': !this.$options.filters['reachLength'](input, maxLength),
          'text-weight': this.$options.filters['reachLength'](input, maxLength) ? 'bold' : 'normal'//,
        }
      },
      fieldActionEnable(field) {
        let self = this;
        if ('NOT_ESPM_LIABILITY' === field) {
          console.log("fieldActionEnable");

          if (self.userRoles !== null && _.size(self.userRoles) > 0) {
            if (_.indexOf(self.userRoles, 'ES_PM_Leader') > -1 || _.indexOf(self.userRoles, 'Admin') > -1) {
              return true;
            }
          }
          if (self.userFunctions !== null && _.size(self.userFunctions) > 0) {
            if (_.indexOf(self.userFunctions, 'ES PM Leader') > -1 || _.indexOf(self.userFunctions, 'Tech Leader') > -1) {
              return true;
            }
          }
          return false
        }
        else {
          return true
        }
      },
      checkActionEnable() {
        let self = this;
        if (!this.$session.has('user_name')) {
          this.$router.push("/");
        }
        // loginUser is gtc owner
        if (self.loginUser !== null && self.createBy !== null && self.loginUser === self.createBy) {
          return true;
        }

        if (self.loginUser !== null && self.groOwner !== null && self.loginUser === self.groOwner) {
          return true;
        }

        if (self.userRoles !== null && _.size(self.userRoles) > 0) {
          if (_.indexOf(self.userRoles, 'ES_PM_Leader') > -1 || _.indexOf(self.userRoles, 'Admin') > -1) {
            return true;
          }
        }
        if (self.userFunctions !== null && _.size(self.userFunctions) > 0) {
          if (_.indexOf(self.userFunctions, 'ES PM Leader') > -1 || _.indexOf(self.userFunctions, 'Tech Leader') > -1) {
            return true;
          }
        }
        return false;
      },

      /* region: Document, Brochure Link */
      showDocumentModal(item) {
        let self = this;
        if (item !== null) {
          _.set(self.documentModalData, 'nreId', item.nre_id);
          _.set(self.documentModalData, 'documentToSync', item.document);
          _.set(self.documentModalData, 'documentToSyncNew', item.document);
        }
        self.$refs['etoSectorSkuDocument'].show();

      },
      /* endregion */

      /* region: Limitation */
      showLimitaionModal(item) {
        let self = this;
        if (item !== null) {
          // self.etoSectorSkuRemark = item.remark;
          _.set(self.remarkModalData, 'nreId', item.nre_id);
          _.set(self.remarkModalData, 'remarkToSync', item.remark);
          _.set(self.remarkModalData, 'remarkToSyncNew', item.remark);
        }

        self.$refs['etoSectorSkuLimitations'].show();
      },
      /* endregion */



      reloadAssess() {
        let self = this;
        let requestData = {
          create_by: self.loginUser,
          username: self.loginUser,
          ftie_id: self.ftieId,
        };
        self.searching = true;
        //eventHub.$emit('loading', true);
        this.$axios
          .post(self.$root.baseUrl + '/ftie/assess-info/', requestData)
          .then(res => {
            let result = res.data;
            console.log('../assess-info/ result');
            //console.log(result);
            //result.eto_sector_sku_list = JSON.parse(result.eto_sector_sku_list);

            if (_.get(result, 'assess_info', null) !== null &&
              _.size(_.get(result, 'assess_info', new Array())) > 0) {
              result.assess_info = JSON.parse(result.assess_info);
            }

            self.assessInfo = result.assess_info

          })
          .finally(() => {
            console.log("COMPLETE reloadAssess");
            _.set(self.updateAssessModalData, 'field', null);
            _.set(self.updateAssessModalData, 'valToUpdate', null);
            _.set(self.updateAssessModalData, 'valBeforeUpdate', null);

            if (self.assessInfo !== null) {
              //self.tags = [];
              self.effectiveValue = [];
              if (_.get(self.assessInfo, 'effective_remark', null) !== null) {
                //self.tags.push(_.get(self.assessInfo, 'effective_remark', ''));
                self.effectiveValue.push(_.get(self.assessInfo, 'effective_remark', ''));
              }
            }
            else {
              //self.tags = [];
              self.effectiveValue = [];
            }
            if (self.assessInfo !== null) {
              self.notEspmLiability = _.get(self.assessInfo, 'not_espm_liability', false);
              self.pocProvided = _.get(self.assessInfo, 'is_poc_provided', false);
            }
            eventHub.$emit('loading', false);
          });
      },

      setAssessUpdateModal(field, val) {
        let self = this;
        _.set(self.updateAssessModalData, 'field', field);
        _.set(self.updateAssessModalData, 'valToUpdate', val)
        /*
        if ('effective_response' === field) {
          _.set(self.updateAssessModalData, 'valToUpdate', val)
        }*/

        return true;
      },
      updateAssessInfo(modalData) {
        let self = this;
        let requestData = {
          ftie_id: self.ftieId,
          create_by: self.loginUser,
          username: self.loginUser,
          edit_field: modalData.field,
          input_info: JSON.parse(JSON.stringify(modalData))
        };

        eventHub.$emit('loading', true);
        self.$axios
          .post(self.$root.baseUrl + '/ftie/assess-info/update/', requestData)
          .then(res => {
            let result = res.data;
            console.log("updateAssessInfo:result");
            //console.log(result);
            let result_obj = null;
            if (res.status === 200) {
              result.save_success = JSON.parse(result.save_success);
              result_obj = result.save_success
            } else if (result.description == "login") {
              self.$session.destroy();
              self.$store.commit('clearToken');
              var url = self.$root.baseUrl + '/auth/logout/';
              self.$axios.get(url)
                .then((res) => {
                  console.log('logout');
                  self.$router.push("/");
                })
              window.location = self.frontEndUrlToUse + 'azure-login';
            } else {
              self.$message.exception('Internal Server Error!');
              console.log(res.description);
            }
          }, (error) => {
            console.log(error);
            self.$message.exception('Internal Server Error!');
          }).finally(() => {
            _.set(self.updateAssessModalData, 'field', null);
            _.set(self.updateAssessModalData, 'valToUpdate', null);
            _.set(self.updateAssessModalData, 'valBeforeUpdate', null);
            self.reloadAssess();
            eventHub.$emit('loading', false);
          });

      },
      /* endregion */



      validate() {
        let self = this;
        // self.$message.warning('Please at least chose one product line to be synced with!', 'SFDC Sync Warning');
        return true;
      },
      /* ENDregion: TODO */
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/framework/GtcFtieTag.vue